import React from 'react';
import { ButtonSecondary } from '@klarna/bubble-ui';
import * as PropTypes from 'prop-types';

const styles = {
  outerContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 100,
  },
};

const SecondaryButton = ({ onClick, children, disabled = false, loading = false, ...props }) => {
  return (
    <div style={styles.outerContainer}>
      <div style={styles.innerContainer}>
        <ButtonSecondary
          {...props}
          type="button"
          onClick={onClick}
          disabled={disabled}
          loading={loading}
        >
          {children}
        </ButtonSecondary>
      </div>
    </div>
  );
};

SecondaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

export default SecondaryButton;
